import React from "react";
import { PerformanceLevelView } from "../../types";
import { axisTicks, bandSegments } from "./reportCardModel";

interface Props {
  /**
   * The band scheme this kind's criteria share, or null when they disagree.
   * Performance levels are authored per criterion, so band NAMES can only be
   * printed along one strip when every criterion beneath it agrees on where
   * they fall. The 0–100 scale itself is universal and always printed — each
   * row's own track carries its own thresholds, and its band chip names the
   * band it reached.
   */
  bands: PerformanceLevelView[] | null;
  note: string;
}

/** The 0–100 strip the kind's gauges are all plotted against. */
const BandAxis: React.FC<Props> = ({ bands, note }) => {
  const ticks = axisTicks(bands);
  const segments = bands && bands.length ? bandSegments(bands) : [];

  return (
    <div className="lane scale">
      <p className="scale-note">{note}</p>
      <div className="axis">
        {ticks.map(({ value, position }, i) => (
          <b
            key={`tick-${i}`}
            style={{
              left: `${position}%`,
              // The end labels are pulled inside the axis so neither overhangs it.
              transform:
                position <= 0
                  ? "none"
                  : position >= 100
                    ? "translateX(-100%)"
                    : undefined,
            }}
          >
            {value}
          </b>
        ))}
        {segments.map(({ name, center }, i) => (
          <span key={`band-${i}`} style={{ left: `${center}%` }}>
            {name}
          </span>
        ))}
      </div>
    </div>
  );
};

export default BandAxis;
